// 9fbef606107a605d69c0edbcd8029e5d
import { renderLabel } from '../../../../../../utils/labels/labelUtilty';

export const getMailingAddressState = (mailingAddress, accountProfileLabels) => {
  if (mailingAddress && mailingAddress.get('isComplete')) {
    return renderLabel(
      accountProfileLabels?.lbl_profile_profileActivityCompleted,
      'lbl_profile_profileActivityCompleted'
    );
  }
  return '';
};

export const getFavStoreState = (defaultStore, accountProfileLabels) => {
  if (defaultStore) {
    return renderLabel(
      accountProfileLabels?.lbl_profile_profileActivityCompleted,
      'lbl_profile_profileActivityCompleted'
    );
  }
  return '';
};

export const getUserBirthdayState = (userBirthday, accountProfileLabels) => {
  if (userBirthday) {
    return renderLabel(
      accountProfileLabels?.lbl_profile_profileActivityCompleted,
      'lbl_profile_profileActivityCompleted'
    );
  }
  return '';
};

export const getAboutYourselfState = (userSurvey, accountProfileLabels) => {
  if (userSurvey && userSurvey.getIn(['0', '0']) && userSurvey.getIn(['1', '0'])) {
    return renderLabel(
      accountProfileLabels?.lbl_profile_profileActivityCompleted,
      'lbl_profile_profileActivityCompleted'
    );
  }
  return '';
};
